import { GETTER_USER_PREFERENCES } from './types';

export default {
    [GETTER_USER_PREFERENCES]: (state) => {
        return state.userPreferences;
    },
}